import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from '../tables/RecordsTable';
import {usePricesSelection} from '../hooks/usePricesSelection';

// FNP-918: the page reads SELECTION and passes it to both consumers — the table
// (which renders the checkboxes) and the header (which renders the batch delete
// button). They are siblings, so the shared parent threads it through.
//
// The state itself lives in the Redux prices.selection slice (FNP-951), so both
// could read it directly; passing it down keeps RecordsTable driven by props
// and therefore testable without a store.
//
// ⚠️ This page is ALSO embedded in the products detail page, inside
// `/products/:id`. RecordsTable reads that route param to narrow to the
// product's prices, so the same component serves both the standalone `/prices`
// route and the products tab.
export const IndexPage = () => {
    const selection = usePricesSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
